module.exports = __webpack_public_path__ + "279d40b1ebfc5b429cd7acc065879d1d.mp3";